import React from 'react';
import PropTypes from 'prop-types';
import APLabelWithText from '../../common/APLabelWithText';
import { formatDate } from '../../../helpers/dateHelper';
import { getBEMClasses } from '../../../helpers/cssClassesHelper';
import '../ConfirmSingleReport/ConfirmSingleReportModal.css';
var confirmSingleReportClasses = getBEMClasses('confirm-single-report');
var ConfirmCyclicalReportForm = function ConfirmCyclicalReportForm(props, context) {
  return React.createElement('div', {
    className: confirmSingleReportClasses()
  }, React.createElement('p', {
    className: confirmSingleReportClasses('title')
  }, context.t('Confirm')), React.createElement(APLabelWithText, {
    label: context.t('Report Type:'),
    text: props.payload.type,
    customClass: confirmSingleReportClasses()
  }), React.createElement(APLabelWithText, {
    label: context.t('Start Date:'),
    text: formatDate(props.payload.startDate),
    customClass: confirmSingleReportClasses()
  }), React.createElement(APLabelWithText, {
    label: context.t('Frequency:'),
    text: props.payload.frequency,
    customClass: confirmSingleReportClasses()
  }));
};
ConfirmCyclicalReportForm.propTypes = {
  payload: PropTypes.object
};
ConfirmCyclicalReportForm.defaultProps = {
  payload: {
    type: '',
    startDate: '',
    frequency: ''
  }
};
ConfirmCyclicalReportForm.contextTypes = {
  t: PropTypes.func.isRequired
};
export default ConfirmCyclicalReportForm;